import { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'

interface Props {
  children: ReactNode[] | ReactNode
  fullHeight?: boolean
  overlayingDrawer?: boolean
}

const Layout = ({ children, fullHeight = true, overlayingDrawer = true }: Props): ReactElement => {
  return (
    <Box
      sx={({ distances, spacing }) => ({
        display: 'flex',
        [fullHeight ? 'height' : 'minHeight']: `calc(100vh - ${distances.navBarHeight})`,
        '@media (min-width: 1920px)': {
          [fullHeight ? 'height' : 'minHeight']: `calc(100vh - ${distances.navBarHeightExpanded})`,
        },
        margin: fullHeight ? spacing(-3) : 0,
        paddingLeft: overlayingDrawer ? 0 : '64px',
        backgroundColor: '#fafafa',
      })}
    >
      {children}
    </Box>
  )
}

export default Layout
